
const stateManager = require('../state/stateManager.js');

module.exports.attributes = {
    code: "code",
    name: "name", 
    language: "language", 
    currency: "currency",
    currencySymbol: "currencySymbol",
    vatCaption: "vatCaption",
    vatPercentage: "vatPercentage",
    isVatInclusive: "isVatInclusive",
    isVatApplicable: "isVatApplicable",
    phoneNumberValidator: "phoneNumberValidator",
    supportEmail: "supportEmail",
    supportPhone: "supportPhone",
    supportWhatsapp: "supportWhatsapp"
}

module.exports.getLocalizationSettings = function ()
{
    const state = stateManager.getStore().getState();

    return state.resolvedLocalizationSettings;
}

function getLocalValue (attribute)
{
    const state = stateManager.getStore().getState();

    const resolvedLocalizationSettings = state.resolvedLocalizationSettings;

    return resolvedLocalizationSettings[attribute];
}

module.exports.getCurrentCurrencyFormatter = function ()
{
    const language = getLocalValue(this.attributes.language);
    const currency = getLocalValue(this.attributes.currency)

    const options = {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2
    };

    return new Intl.NumberFormat(language, options);
}

module.exports.getPhoneNumberValidator = function ()
{
    return getLocalValue(this.attributes.phoneNumberValidator)
}

module.exports.getVatCaption = function ()
{
    return getLocalValue(this.attributes.vatCaption)
}

module.exports.isVatInclusive = function()
{
    return getLocalValue(this.attributes.isVatInclusive);
}

module.exports.isVatApplicable = function()
{
    return getLocalValue(this.attributes.isVatApplicable);
}

module.exports.getCurrency = function()
{
    return getLocalValue(this.attributes.currency);
}